/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as JoinRouteImport } from './routes/join'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authAuthConfirmedRouteImport } from './routes/(auth)/auth-confirmed'
import { Route as appTermsAndConditionsRouteImport } from './routes/(app)/termsAndConditions'
import { Route as appRequestsRouteImport } from './routes/(app)/requests'
import { Route as appHomeRouteImport } from './routes/(app)/home'
import { Route as appOnboardingRouteRouteImport } from './routes/(app)/onboarding/route'
import { Route as appCareRouteRouteImport } from './routes/(app)/care/route'
import { Route as appVisitsIndexRouteImport } from './routes/(app)/visits/index'
import { Route as appCareIndexRouteImport } from './routes/(app)/care/index'
import { Route as appVisitsRepeatingVisitsRouteImport } from './routes/(app)/visits/repeating-visits'
import { Route as appVisitsAddRouteImport } from './routes/(app)/visits/add'
import { Route as appOnboardingVisitTypeRouteImport } from './routes/(app)/onboarding/visit-type'
import { Route as appOnboardingVisitSavedRouteImport } from './routes/(app)/onboarding/visit-saved'
import { Route as appOnboardingVisitDetailsRouteImport } from './routes/(app)/onboarding/visit-details'
import { Route as appOnboardingVisitAddressRouteImport } from './routes/(app)/onboarding/visit-address'
import { Route as appOnboardingTermsRouteImport } from './routes/(app)/onboarding/terms'
import { Route as appOnboardingShareInviteRouteImport } from './routes/(app)/onboarding/share-invite'
import { Route as appOnboardingSelectRoleRouteImport } from './routes/(app)/onboarding/select-role'
import { Route as appOnboardingInviteCaregiverRouteImport } from './routes/(app)/onboarding/invite-caregiver'
import { Route as appOnboardingEnableNotificationsRouteImport } from './routes/(app)/onboarding/enable-notifications'
import { Route as appOnboardingCongratsRouteImport } from './routes/(app)/onboarding/congrats'
import { Route as appOnboardingConfirmRoleRouteImport } from './routes/(app)/onboarding/confirm-role'
import { Route as appOnboardingConfirmInfoRouteImport } from './routes/(app)/onboarding/confirm-info'
import { Route as appOnboardingConfirmAssistingRouteImport } from './routes/(app)/onboarding/confirm-assisting'
import { Route as appOnboardingAccountCreatedRouteImport } from './routes/(app)/onboarding/account-created'
import { Route as appDevResetOnboardingRouteImport } from './routes/(app)/dev/reset-onboarding'
import { Route as appAccountDeleteRouteImport } from './routes/(app)/account/delete'
import { Route as appCareTeamIndexRouteImport } from './routes/(app)/care/team/index'
import { Route as appVisitsSummarySuccessRouteImport } from './routes/(app)/visits/summary/success'
import { Route as appVisitsEditVisitScheduleRidRouteImport } from './routes/(app)/visits/edit.$visitScheduleRid'
import { Route as appVisitsDetailVisitScheduleRidRouteImport } from './routes/(app)/visits/detail.$visitScheduleRid'
import { Route as appCareTeamInviteRouteImport } from './routes/(app)/care/team/invite'
import { Route as appCareDayToDayRoutinesRouteImport } from './routes/(app)/care/day-to-day/routines'
import { Route as appCareDayToDayMobilityRouteImport } from './routes/(app)/care/day-to-day/mobility'
import { Route as appCareDayToDayMemoryRouteImport } from './routes/(app)/care/day-to-day/memory'
import { Route as appCareDayToDayMealsRouteImport } from './routes/(app)/care/day-to-day/meals'
import { Route as appCareDayToDayIntroRouteImport } from './routes/(app)/care/day-to-day/intro'
import { Route as appCareAdlsIntroRouteImport } from './routes/(app)/care/adls/intro'
import { Route as appCareAdlsEditRouteImport } from './routes/(app)/care/adls/edit'
import { Route as appVisitsSummaryDetailVisitRidRouteImport } from './routes/(app)/visits/summary/detail.$visitRid'
import { Route as appVisitsSummaryAddVisitRidRouteImport } from './routes/(app)/visits/summary/add.$visitRid'
import { Route as appCareTeamMemberTeamMemberRidRouteImport } from './routes/(app)/care/team/member/$teamMemberRid'
import { Route as appCareTeamMemberEditTeamMemberRidRouteImport } from './routes/(app)/care/team/member/edit.$teamMemberRid'

const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authAuthConfirmedRoute = authAuthConfirmedRouteImport.update({
  id: '/auth-confirmed',
  path: '/auth-confirmed',
  getParentRoute: () => authRouteRoute,
} as any)
const appTermsAndConditionsRoute = appTermsAndConditionsRouteImport.update({
  id: '/termsAndConditions',
  path: '/termsAndConditions',
  getParentRoute: () => appRouteRoute,
} as any)
const appRequestsRoute = appRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => appRouteRoute,
} as any)
const appHomeRoute = appHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => appRouteRoute,
} as any)
const appOnboardingRouteRoute = appOnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => appRouteRoute,
} as any)
const appCareRouteRoute = appCareRouteRouteImport.update({
  id: '/care',
  path: '/care',
  getParentRoute: () => appRouteRoute,
} as any)
const appVisitsIndexRoute = appVisitsIndexRouteImport.update({
  id: '/visits/',
  path: '/visits/',
  getParentRoute: () => appRouteRoute,
} as any)
const appCareIndexRoute = appCareIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appVisitsRepeatingVisitsRoute =
  appVisitsRepeatingVisitsRouteImport.update({
    id: '/visits/repeating-visits',
    path: '/visits/repeating-visits',
    getParentRoute: () => appRouteRoute,
  } as any)
const appVisitsAddRoute = appVisitsAddRouteImport.update({
  id: '/visits/add',
  path: '/visits/add',
  getParentRoute: () => appRouteRoute,
} as any)
const appOnboardingVisitTypeRoute = appOnboardingVisitTypeRouteImport.update({
  id: '/visit-type',
  path: '/visit-type',
  getParentRoute: () => appOnboardingRouteRoute,
} as any)
const appOnboardingVisitSavedRoute = appOnboardingVisitSavedRouteImport.update({
  id: '/visit-saved',
  path: '/visit-saved',
  getParentRoute: () => appOnboardingRouteRoute,
} as any)
const appOnboardingVisitDetailsRoute =
  appOnboardingVisitDetailsRouteImport.update({
    id: '/visit-details',
    path: '/visit-details',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingVisitAddressRoute =
  appOnboardingVisitAddressRouteImport.update({
    id: '/visit-address',
    path: '/visit-address',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingTermsRoute = appOnboardingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => appOnboardingRouteRoute,
} as any)
const appOnboardingShareInviteRoute =
  appOnboardingShareInviteRouteImport.update({
    id: '/share-invite',
    path: '/share-invite',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingSelectRoleRoute = appOnboardingSelectRoleRouteImport.update({
  id: '/select-role',
  path: '/select-role',
  getParentRoute: () => appOnboardingRouteRoute,
} as any)
const appOnboardingInviteCaregiverRoute =
  appOnboardingInviteCaregiverRouteImport.update({
    id: '/invite-caregiver',
    path: '/invite-caregiver',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingEnableNotificationsRoute =
  appOnboardingEnableNotificationsRouteImport.update({
    id: '/enable-notifications',
    path: '/enable-notifications',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingCongratsRoute = appOnboardingCongratsRouteImport.update({
  id: '/congrats',
  path: '/congrats',
  getParentRoute: () => appOnboardingRouteRoute,
} as any)
const appOnboardingConfirmRoleRoute =
  appOnboardingConfirmRoleRouteImport.update({
    id: '/confirm-role',
    path: '/confirm-role',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingConfirmInfoRoute =
  appOnboardingConfirmInfoRouteImport.update({
    id: '/confirm-info',
    path: '/confirm-info',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingConfirmAssistingRoute =
  appOnboardingConfirmAssistingRouteImport.update({
    id: '/confirm-assisting',
    path: '/confirm-assisting',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appOnboardingAccountCreatedRoute =
  appOnboardingAccountCreatedRouteImport.update({
    id: '/account-created',
    path: '/account-created',
    getParentRoute: () => appOnboardingRouteRoute,
  } as any)
const appDevResetOnboardingRoute = appDevResetOnboardingRouteImport.update({
  id: '/dev/reset-onboarding',
  path: '/dev/reset-onboarding',
  getParentRoute: () => appRouteRoute,
} as any)
const appAccountDeleteRoute = appAccountDeleteRouteImport.update({
  id: '/account/delete',
  path: '/account/delete',
  getParentRoute: () => appRouteRoute,
} as any)
const appCareTeamIndexRoute = appCareTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appVisitsSummarySuccessRoute = appVisitsSummarySuccessRouteImport.update({
  id: '/visits/summary/success',
  path: '/visits/summary/success',
  getParentRoute: () => appRouteRoute,
} as any)
const appVisitsEditVisitScheduleRidRoute =
  appVisitsEditVisitScheduleRidRouteImport.update({
    id: '/visits/edit/$visitScheduleRid',
    path: '/visits/edit/$visitScheduleRid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appVisitsDetailVisitScheduleRidRoute =
  appVisitsDetailVisitScheduleRidRouteImport.update({
    id: '/visits/detail/$visitScheduleRid',
    path: '/visits/detail/$visitScheduleRid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appCareTeamInviteRoute = appCareTeamInviteRouteImport.update({
  id: '/team/invite',
  path: '/team/invite',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareDayToDayRoutinesRoute = appCareDayToDayRoutinesRouteImport.update({
  id: '/day-to-day/routines',
  path: '/day-to-day/routines',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareDayToDayMobilityRoute = appCareDayToDayMobilityRouteImport.update({
  id: '/day-to-day/mobility',
  path: '/day-to-day/mobility',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareDayToDayMemoryRoute = appCareDayToDayMemoryRouteImport.update({
  id: '/day-to-day/memory',
  path: '/day-to-day/memory',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareDayToDayMealsRoute = appCareDayToDayMealsRouteImport.update({
  id: '/day-to-day/meals',
  path: '/day-to-day/meals',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareDayToDayIntroRoute = appCareDayToDayIntroRouteImport.update({
  id: '/day-to-day/intro',
  path: '/day-to-day/intro',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareAdlsIntroRoute = appCareAdlsIntroRouteImport.update({
  id: '/adls/intro',
  path: '/adls/intro',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appCareAdlsEditRoute = appCareAdlsEditRouteImport.update({
  id: '/adls/edit',
  path: '/adls/edit',
  getParentRoute: () => appCareRouteRoute,
} as any)
const appVisitsSummaryDetailVisitRidRoute =
  appVisitsSummaryDetailVisitRidRouteImport.update({
    id: '/visits/summary/detail/$visitRid',
    path: '/visits/summary/detail/$visitRid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appVisitsSummaryAddVisitRidRoute =
  appVisitsSummaryAddVisitRidRouteImport.update({
    id: '/visits/summary/add/$visitRid',
    path: '/visits/summary/add/$visitRid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appCareTeamMemberTeamMemberRidRoute =
  appCareTeamMemberTeamMemberRidRouteImport.update({
    id: '/team/member/$teamMemberRid',
    path: '/team/member/$teamMemberRid',
    getParentRoute: () => appCareRouteRoute,
  } as any)
const appCareTeamMemberEditTeamMemberRidRoute =
  appCareTeamMemberEditTeamMemberRidRouteImport.update({
    id: '/team/member/edit/$teamMemberRid',
    path: '/team/member/edit/$teamMemberRid',
    getParentRoute: () => appCareRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof authRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/care': typeof appCareRouteRouteWithChildren
  '/onboarding': typeof appOnboardingRouteRouteWithChildren
  '/home': typeof appHomeRoute
  '/requests': typeof appRequestsRoute
  '/termsAndConditions': typeof appTermsAndConditionsRoute
  '/auth-confirmed': typeof authAuthConfirmedRoute
  '/login': typeof authLoginRoute
  '/account/delete': typeof appAccountDeleteRoute
  '/dev/reset-onboarding': typeof appDevResetOnboardingRoute
  '/onboarding/account-created': typeof appOnboardingAccountCreatedRoute
  '/onboarding/confirm-assisting': typeof appOnboardingConfirmAssistingRoute
  '/onboarding/confirm-info': typeof appOnboardingConfirmInfoRoute
  '/onboarding/confirm-role': typeof appOnboardingConfirmRoleRoute
  '/onboarding/congrats': typeof appOnboardingCongratsRoute
  '/onboarding/enable-notifications': typeof appOnboardingEnableNotificationsRoute
  '/onboarding/invite-caregiver': typeof appOnboardingInviteCaregiverRoute
  '/onboarding/select-role': typeof appOnboardingSelectRoleRoute
  '/onboarding/share-invite': typeof appOnboardingShareInviteRoute
  '/onboarding/terms': typeof appOnboardingTermsRoute
  '/onboarding/visit-address': typeof appOnboardingVisitAddressRoute
  '/onboarding/visit-details': typeof appOnboardingVisitDetailsRoute
  '/onboarding/visit-saved': typeof appOnboardingVisitSavedRoute
  '/onboarding/visit-type': typeof appOnboardingVisitTypeRoute
  '/visits/add': typeof appVisitsAddRoute
  '/visits/repeating-visits': typeof appVisitsRepeatingVisitsRoute
  '/care/': typeof appCareIndexRoute
  '/visits': typeof appVisitsIndexRoute
  '/care/adls/edit': typeof appCareAdlsEditRoute
  '/care/adls/intro': typeof appCareAdlsIntroRoute
  '/care/day-to-day/intro': typeof appCareDayToDayIntroRoute
  '/care/day-to-day/meals': typeof appCareDayToDayMealsRoute
  '/care/day-to-day/memory': typeof appCareDayToDayMemoryRoute
  '/care/day-to-day/mobility': typeof appCareDayToDayMobilityRoute
  '/care/day-to-day/routines': typeof appCareDayToDayRoutinesRoute
  '/care/team/invite': typeof appCareTeamInviteRoute
  '/visits/detail/$visitScheduleRid': typeof appVisitsDetailVisitScheduleRidRoute
  '/visits/edit/$visitScheduleRid': typeof appVisitsEditVisitScheduleRidRoute
  '/visits/summary/success': typeof appVisitsSummarySuccessRoute
  '/care/team': typeof appCareTeamIndexRoute
  '/care/team/member/$teamMemberRid': typeof appCareTeamMemberTeamMemberRidRoute
  '/visits/summary/add/$visitRid': typeof appVisitsSummaryAddVisitRidRoute
  '/visits/summary/detail/$visitRid': typeof appVisitsSummaryDetailVisitRidRoute
  '/care/team/member/edit/$teamMemberRid': typeof appCareTeamMemberEditTeamMemberRidRoute
}
export interface FileRoutesByTo {
  '/': typeof authRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/onboarding': typeof appOnboardingRouteRouteWithChildren
  '/home': typeof appHomeRoute
  '/requests': typeof appRequestsRoute
  '/termsAndConditions': typeof appTermsAndConditionsRoute
  '/auth-confirmed': typeof authAuthConfirmedRoute
  '/login': typeof authLoginRoute
  '/account/delete': typeof appAccountDeleteRoute
  '/dev/reset-onboarding': typeof appDevResetOnboardingRoute
  '/onboarding/account-created': typeof appOnboardingAccountCreatedRoute
  '/onboarding/confirm-assisting': typeof appOnboardingConfirmAssistingRoute
  '/onboarding/confirm-info': typeof appOnboardingConfirmInfoRoute
  '/onboarding/confirm-role': typeof appOnboardingConfirmRoleRoute
  '/onboarding/congrats': typeof appOnboardingCongratsRoute
  '/onboarding/enable-notifications': typeof appOnboardingEnableNotificationsRoute
  '/onboarding/invite-caregiver': typeof appOnboardingInviteCaregiverRoute
  '/onboarding/select-role': typeof appOnboardingSelectRoleRoute
  '/onboarding/share-invite': typeof appOnboardingShareInviteRoute
  '/onboarding/terms': typeof appOnboardingTermsRoute
  '/onboarding/visit-address': typeof appOnboardingVisitAddressRoute
  '/onboarding/visit-details': typeof appOnboardingVisitDetailsRoute
  '/onboarding/visit-saved': typeof appOnboardingVisitSavedRoute
  '/onboarding/visit-type': typeof appOnboardingVisitTypeRoute
  '/visits/add': typeof appVisitsAddRoute
  '/visits/repeating-visits': typeof appVisitsRepeatingVisitsRoute
  '/care': typeof appCareIndexRoute
  '/visits': typeof appVisitsIndexRoute
  '/care/adls/edit': typeof appCareAdlsEditRoute
  '/care/adls/intro': typeof appCareAdlsIntroRoute
  '/care/day-to-day/intro': typeof appCareDayToDayIntroRoute
  '/care/day-to-day/meals': typeof appCareDayToDayMealsRoute
  '/care/day-to-day/memory': typeof appCareDayToDayMemoryRoute
  '/care/day-to-day/mobility': typeof appCareDayToDayMobilityRoute
  '/care/day-to-day/routines': typeof appCareDayToDayRoutinesRoute
  '/care/team/invite': typeof appCareTeamInviteRoute
  '/visits/detail/$visitScheduleRid': typeof appVisitsDetailVisitScheduleRidRoute
  '/visits/edit/$visitScheduleRid': typeof appVisitsEditVisitScheduleRidRoute
  '/visits/summary/success': typeof appVisitsSummarySuccessRoute
  '/care/team': typeof appCareTeamIndexRoute
  '/care/team/member/$teamMemberRid': typeof appCareTeamMemberTeamMemberRidRoute
  '/visits/summary/add/$visitRid': typeof appVisitsSummaryAddVisitRidRoute
  '/visits/summary/detail/$visitRid': typeof appVisitsSummaryDetailVisitRidRoute
  '/care/team/member/edit/$teamMemberRid': typeof appCareTeamMemberEditTeamMemberRidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/(auth)': typeof authRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/(app)/care': typeof appCareRouteRouteWithChildren
  '/(app)/onboarding': typeof appOnboardingRouteRouteWithChildren
  '/(app)/home': typeof appHomeRoute
  '/(app)/requests': typeof appRequestsRoute
  '/(app)/termsAndConditions': typeof appTermsAndConditionsRoute
  '/(auth)/auth-confirmed': typeof authAuthConfirmedRoute
  '/(auth)/login': typeof authLoginRoute
  '/(app)/account/delete': typeof appAccountDeleteRoute
  '/(app)/dev/reset-onboarding': typeof appDevResetOnboardingRoute
  '/(app)/onboarding/account-created': typeof appOnboardingAccountCreatedRoute
  '/(app)/onboarding/confirm-assisting': typeof appOnboardingConfirmAssistingRoute
  '/(app)/onboarding/confirm-info': typeof appOnboardingConfirmInfoRoute
  '/(app)/onboarding/confirm-role': typeof appOnboardingConfirmRoleRoute
  '/(app)/onboarding/congrats': typeof appOnboardingCongratsRoute
  '/(app)/onboarding/enable-notifications': typeof appOnboardingEnableNotificationsRoute
  '/(app)/onboarding/invite-caregiver': typeof appOnboardingInviteCaregiverRoute
  '/(app)/onboarding/select-role': typeof appOnboardingSelectRoleRoute
  '/(app)/onboarding/share-invite': typeof appOnboardingShareInviteRoute
  '/(app)/onboarding/terms': typeof appOnboardingTermsRoute
  '/(app)/onboarding/visit-address': typeof appOnboardingVisitAddressRoute
  '/(app)/onboarding/visit-details': typeof appOnboardingVisitDetailsRoute
  '/(app)/onboarding/visit-saved': typeof appOnboardingVisitSavedRoute
  '/(app)/onboarding/visit-type': typeof appOnboardingVisitTypeRoute
  '/(app)/visits/add': typeof appVisitsAddRoute
  '/(app)/visits/repeating-visits': typeof appVisitsRepeatingVisitsRoute
  '/(app)/care/': typeof appCareIndexRoute
  '/(app)/visits/': typeof appVisitsIndexRoute
  '/(app)/care/adls/edit': typeof appCareAdlsEditRoute
  '/(app)/care/adls/intro': typeof appCareAdlsIntroRoute
  '/(app)/care/day-to-day/intro': typeof appCareDayToDayIntroRoute
  '/(app)/care/day-to-day/meals': typeof appCareDayToDayMealsRoute
  '/(app)/care/day-to-day/memory': typeof appCareDayToDayMemoryRoute
  '/(app)/care/day-to-day/mobility': typeof appCareDayToDayMobilityRoute
  '/(app)/care/day-to-day/routines': typeof appCareDayToDayRoutinesRoute
  '/(app)/care/team/invite': typeof appCareTeamInviteRoute
  '/(app)/visits/detail/$visitScheduleRid': typeof appVisitsDetailVisitScheduleRidRoute
  '/(app)/visits/edit/$visitScheduleRid': typeof appVisitsEditVisitScheduleRidRoute
  '/(app)/visits/summary/success': typeof appVisitsSummarySuccessRoute
  '/(app)/care/team/': typeof appCareTeamIndexRoute
  '/(app)/care/team/member/$teamMemberRid': typeof appCareTeamMemberTeamMemberRidRoute
  '/(app)/visits/summary/add/$visitRid': typeof appVisitsSummaryAddVisitRidRoute
  '/(app)/visits/summary/detail/$visitRid': typeof appVisitsSummaryDetailVisitRidRoute
  '/(app)/care/team/member/edit/$teamMemberRid': typeof appCareTeamMemberEditTeamMemberRidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/care'
    | '/onboarding'
    | '/home'
    | '/requests'
    | '/termsAndConditions'
    | '/auth-confirmed'
    | '/login'
    | '/account/delete'
    | '/dev/reset-onboarding'
    | '/onboarding/account-created'
    | '/onboarding/confirm-assisting'
    | '/onboarding/confirm-info'
    | '/onboarding/confirm-role'
    | '/onboarding/congrats'
    | '/onboarding/enable-notifications'
    | '/onboarding/invite-caregiver'
    | '/onboarding/select-role'
    | '/onboarding/share-invite'
    | '/onboarding/terms'
    | '/onboarding/visit-address'
    | '/onboarding/visit-details'
    | '/onboarding/visit-saved'
    | '/onboarding/visit-type'
    | '/visits/add'
    | '/visits/repeating-visits'
    | '/care/'
    | '/visits'
    | '/care/adls/edit'
    | '/care/adls/intro'
    | '/care/day-to-day/intro'
    | '/care/day-to-day/meals'
    | '/care/day-to-day/memory'
    | '/care/day-to-day/mobility'
    | '/care/day-to-day/routines'
    | '/care/team/invite'
    | '/visits/detail/$visitScheduleRid'
    | '/visits/edit/$visitScheduleRid'
    | '/visits/summary/success'
    | '/care/team'
    | '/care/team/member/$teamMemberRid'
    | '/visits/summary/add/$visitRid'
    | '/visits/summary/detail/$visitRid'
    | '/care/team/member/edit/$teamMemberRid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/join'
    | '/onboarding'
    | '/home'
    | '/requests'
    | '/termsAndConditions'
    | '/auth-confirmed'
    | '/login'
    | '/account/delete'
    | '/dev/reset-onboarding'
    | '/onboarding/account-created'
    | '/onboarding/confirm-assisting'
    | '/onboarding/confirm-info'
    | '/onboarding/confirm-role'
    | '/onboarding/congrats'
    | '/onboarding/enable-notifications'
    | '/onboarding/invite-caregiver'
    | '/onboarding/select-role'
    | '/onboarding/share-invite'
    | '/onboarding/terms'
    | '/onboarding/visit-address'
    | '/onboarding/visit-details'
    | '/onboarding/visit-saved'
    | '/onboarding/visit-type'
    | '/visits/add'
    | '/visits/repeating-visits'
    | '/care'
    | '/visits'
    | '/care/adls/edit'
    | '/care/adls/intro'
    | '/care/day-to-day/intro'
    | '/care/day-to-day/meals'
    | '/care/day-to-day/memory'
    | '/care/day-to-day/mobility'
    | '/care/day-to-day/routines'
    | '/care/team/invite'
    | '/visits/detail/$visitScheduleRid'
    | '/visits/edit/$visitScheduleRid'
    | '/visits/summary/success'
    | '/care/team'
    | '/care/team/member/$teamMemberRid'
    | '/visits/summary/add/$visitRid'
    | '/visits/summary/detail/$visitRid'
    | '/care/team/member/edit/$teamMemberRid'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/(auth)'
    | '/join'
    | '/(app)/care'
    | '/(app)/onboarding'
    | '/(app)/home'
    | '/(app)/requests'
    | '/(app)/termsAndConditions'
    | '/(auth)/auth-confirmed'
    | '/(auth)/login'
    | '/(app)/account/delete'
    | '/(app)/dev/reset-onboarding'
    | '/(app)/onboarding/account-created'
    | '/(app)/onboarding/confirm-assisting'
    | '/(app)/onboarding/confirm-info'
    | '/(app)/onboarding/confirm-role'
    | '/(app)/onboarding/congrats'
    | '/(app)/onboarding/enable-notifications'
    | '/(app)/onboarding/invite-caregiver'
    | '/(app)/onboarding/select-role'
    | '/(app)/onboarding/share-invite'
    | '/(app)/onboarding/terms'
    | '/(app)/onboarding/visit-address'
    | '/(app)/onboarding/visit-details'
    | '/(app)/onboarding/visit-saved'
    | '/(app)/onboarding/visit-type'
    | '/(app)/visits/add'
    | '/(app)/visits/repeating-visits'
    | '/(app)/care/'
    | '/(app)/visits/'
    | '/(app)/care/adls/edit'
    | '/(app)/care/adls/intro'
    | '/(app)/care/day-to-day/intro'
    | '/(app)/care/day-to-day/meals'
    | '/(app)/care/day-to-day/memory'
    | '/(app)/care/day-to-day/mobility'
    | '/(app)/care/day-to-day/routines'
    | '/(app)/care/team/invite'
    | '/(app)/visits/detail/$visitScheduleRid'
    | '/(app)/visits/edit/$visitScheduleRid'
    | '/(app)/visits/summary/success'
    | '/(app)/care/team/'
    | '/(app)/care/team/member/$teamMemberRid'
    | '/(app)/visits/summary/add/$visitRid'
    | '/(app)/visits/summary/detail/$visitRid'
    | '/(app)/care/team/member/edit/$teamMemberRid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  authRouteRoute: typeof authRouteRouteWithChildren
  JoinRoute: typeof JoinRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/auth-confirmed': {
      id: '/(auth)/auth-confirmed'
      path: '/auth-confirmed'
      fullPath: '/auth-confirmed'
      preLoaderRoute: typeof authAuthConfirmedRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(app)/termsAndConditions': {
      id: '/(app)/termsAndConditions'
      path: '/termsAndConditions'
      fullPath: '/termsAndConditions'
      preLoaderRoute: typeof appTermsAndConditionsRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/requests': {
      id: '/(app)/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof appRequestsRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/home': {
      id: '/(app)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof appHomeRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/onboarding': {
      id: '/(app)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof appOnboardingRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/care': {
      id: '/(app)/care'
      path: '/care'
      fullPath: '/care'
      preLoaderRoute: typeof appCareRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/visits/': {
      id: '/(app)/visits/'
      path: '/visits'
      fullPath: '/visits'
      preLoaderRoute: typeof appVisitsIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/care/': {
      id: '/(app)/care/'
      path: '/'
      fullPath: '/care/'
      preLoaderRoute: typeof appCareIndexRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/visits/repeating-visits': {
      id: '/(app)/visits/repeating-visits'
      path: '/visits/repeating-visits'
      fullPath: '/visits/repeating-visits'
      preLoaderRoute: typeof appVisitsRepeatingVisitsRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/visits/add': {
      id: '/(app)/visits/add'
      path: '/visits/add'
      fullPath: '/visits/add'
      preLoaderRoute: typeof appVisitsAddRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/onboarding/visit-type': {
      id: '/(app)/onboarding/visit-type'
      path: '/visit-type'
      fullPath: '/onboarding/visit-type'
      preLoaderRoute: typeof appOnboardingVisitTypeRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/visit-saved': {
      id: '/(app)/onboarding/visit-saved'
      path: '/visit-saved'
      fullPath: '/onboarding/visit-saved'
      preLoaderRoute: typeof appOnboardingVisitSavedRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/visit-details': {
      id: '/(app)/onboarding/visit-details'
      path: '/visit-details'
      fullPath: '/onboarding/visit-details'
      preLoaderRoute: typeof appOnboardingVisitDetailsRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/visit-address': {
      id: '/(app)/onboarding/visit-address'
      path: '/visit-address'
      fullPath: '/onboarding/visit-address'
      preLoaderRoute: typeof appOnboardingVisitAddressRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/terms': {
      id: '/(app)/onboarding/terms'
      path: '/terms'
      fullPath: '/onboarding/terms'
      preLoaderRoute: typeof appOnboardingTermsRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/share-invite': {
      id: '/(app)/onboarding/share-invite'
      path: '/share-invite'
      fullPath: '/onboarding/share-invite'
      preLoaderRoute: typeof appOnboardingShareInviteRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/select-role': {
      id: '/(app)/onboarding/select-role'
      path: '/select-role'
      fullPath: '/onboarding/select-role'
      preLoaderRoute: typeof appOnboardingSelectRoleRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/invite-caregiver': {
      id: '/(app)/onboarding/invite-caregiver'
      path: '/invite-caregiver'
      fullPath: '/onboarding/invite-caregiver'
      preLoaderRoute: typeof appOnboardingInviteCaregiverRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/enable-notifications': {
      id: '/(app)/onboarding/enable-notifications'
      path: '/enable-notifications'
      fullPath: '/onboarding/enable-notifications'
      preLoaderRoute: typeof appOnboardingEnableNotificationsRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/congrats': {
      id: '/(app)/onboarding/congrats'
      path: '/congrats'
      fullPath: '/onboarding/congrats'
      preLoaderRoute: typeof appOnboardingCongratsRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/confirm-role': {
      id: '/(app)/onboarding/confirm-role'
      path: '/confirm-role'
      fullPath: '/onboarding/confirm-role'
      preLoaderRoute: typeof appOnboardingConfirmRoleRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/confirm-info': {
      id: '/(app)/onboarding/confirm-info'
      path: '/confirm-info'
      fullPath: '/onboarding/confirm-info'
      preLoaderRoute: typeof appOnboardingConfirmInfoRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/confirm-assisting': {
      id: '/(app)/onboarding/confirm-assisting'
      path: '/confirm-assisting'
      fullPath: '/onboarding/confirm-assisting'
      preLoaderRoute: typeof appOnboardingConfirmAssistingRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/onboarding/account-created': {
      id: '/(app)/onboarding/account-created'
      path: '/account-created'
      fullPath: '/onboarding/account-created'
      preLoaderRoute: typeof appOnboardingAccountCreatedRouteImport
      parentRoute: typeof appOnboardingRouteRoute
    }
    '/(app)/dev/reset-onboarding': {
      id: '/(app)/dev/reset-onboarding'
      path: '/dev/reset-onboarding'
      fullPath: '/dev/reset-onboarding'
      preLoaderRoute: typeof appDevResetOnboardingRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/account/delete': {
      id: '/(app)/account/delete'
      path: '/account/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof appAccountDeleteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/care/team/': {
      id: '/(app)/care/team/'
      path: '/team'
      fullPath: '/care/team'
      preLoaderRoute: typeof appCareTeamIndexRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/visits/summary/success': {
      id: '/(app)/visits/summary/success'
      path: '/visits/summary/success'
      fullPath: '/visits/summary/success'
      preLoaderRoute: typeof appVisitsSummarySuccessRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/visits/edit/$visitScheduleRid': {
      id: '/(app)/visits/edit/$visitScheduleRid'
      path: '/visits/edit/$visitScheduleRid'
      fullPath: '/visits/edit/$visitScheduleRid'
      preLoaderRoute: typeof appVisitsEditVisitScheduleRidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/visits/detail/$visitScheduleRid': {
      id: '/(app)/visits/detail/$visitScheduleRid'
      path: '/visits/detail/$visitScheduleRid'
      fullPath: '/visits/detail/$visitScheduleRid'
      preLoaderRoute: typeof appVisitsDetailVisitScheduleRidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/care/team/invite': {
      id: '/(app)/care/team/invite'
      path: '/team/invite'
      fullPath: '/care/team/invite'
      preLoaderRoute: typeof appCareTeamInviteRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/day-to-day/routines': {
      id: '/(app)/care/day-to-day/routines'
      path: '/day-to-day/routines'
      fullPath: '/care/day-to-day/routines'
      preLoaderRoute: typeof appCareDayToDayRoutinesRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/day-to-day/mobility': {
      id: '/(app)/care/day-to-day/mobility'
      path: '/day-to-day/mobility'
      fullPath: '/care/day-to-day/mobility'
      preLoaderRoute: typeof appCareDayToDayMobilityRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/day-to-day/memory': {
      id: '/(app)/care/day-to-day/memory'
      path: '/day-to-day/memory'
      fullPath: '/care/day-to-day/memory'
      preLoaderRoute: typeof appCareDayToDayMemoryRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/day-to-day/meals': {
      id: '/(app)/care/day-to-day/meals'
      path: '/day-to-day/meals'
      fullPath: '/care/day-to-day/meals'
      preLoaderRoute: typeof appCareDayToDayMealsRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/day-to-day/intro': {
      id: '/(app)/care/day-to-day/intro'
      path: '/day-to-day/intro'
      fullPath: '/care/day-to-day/intro'
      preLoaderRoute: typeof appCareDayToDayIntroRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/adls/intro': {
      id: '/(app)/care/adls/intro'
      path: '/adls/intro'
      fullPath: '/care/adls/intro'
      preLoaderRoute: typeof appCareAdlsIntroRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/adls/edit': {
      id: '/(app)/care/adls/edit'
      path: '/adls/edit'
      fullPath: '/care/adls/edit'
      preLoaderRoute: typeof appCareAdlsEditRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/visits/summary/detail/$visitRid': {
      id: '/(app)/visits/summary/detail/$visitRid'
      path: '/visits/summary/detail/$visitRid'
      fullPath: '/visits/summary/detail/$visitRid'
      preLoaderRoute: typeof appVisitsSummaryDetailVisitRidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/visits/summary/add/$visitRid': {
      id: '/(app)/visits/summary/add/$visitRid'
      path: '/visits/summary/add/$visitRid'
      fullPath: '/visits/summary/add/$visitRid'
      preLoaderRoute: typeof appVisitsSummaryAddVisitRidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/care/team/member/$teamMemberRid': {
      id: '/(app)/care/team/member/$teamMemberRid'
      path: '/team/member/$teamMemberRid'
      fullPath: '/care/team/member/$teamMemberRid'
      preLoaderRoute: typeof appCareTeamMemberTeamMemberRidRouteImport
      parentRoute: typeof appCareRouteRoute
    }
    '/(app)/care/team/member/edit/$teamMemberRid': {
      id: '/(app)/care/team/member/edit/$teamMemberRid'
      path: '/team/member/edit/$teamMemberRid'
      fullPath: '/care/team/member/edit/$teamMemberRid'
      preLoaderRoute: typeof appCareTeamMemberEditTeamMemberRidRouteImport
      parentRoute: typeof appCareRouteRoute
    }
  }
}

interface appCareRouteRouteChildren {
  appCareIndexRoute: typeof appCareIndexRoute
  appCareAdlsEditRoute: typeof appCareAdlsEditRoute
  appCareAdlsIntroRoute: typeof appCareAdlsIntroRoute
  appCareDayToDayIntroRoute: typeof appCareDayToDayIntroRoute
  appCareDayToDayMealsRoute: typeof appCareDayToDayMealsRoute
  appCareDayToDayMemoryRoute: typeof appCareDayToDayMemoryRoute
  appCareDayToDayMobilityRoute: typeof appCareDayToDayMobilityRoute
  appCareDayToDayRoutinesRoute: typeof appCareDayToDayRoutinesRoute
  appCareTeamInviteRoute: typeof appCareTeamInviteRoute
  appCareTeamIndexRoute: typeof appCareTeamIndexRoute
  appCareTeamMemberTeamMemberRidRoute: typeof appCareTeamMemberTeamMemberRidRoute
  appCareTeamMemberEditTeamMemberRidRoute: typeof appCareTeamMemberEditTeamMemberRidRoute
}

const appCareRouteRouteChildren: appCareRouteRouteChildren = {
  appCareIndexRoute: appCareIndexRoute,
  appCareAdlsEditRoute: appCareAdlsEditRoute,
  appCareAdlsIntroRoute: appCareAdlsIntroRoute,
  appCareDayToDayIntroRoute: appCareDayToDayIntroRoute,
  appCareDayToDayMealsRoute: appCareDayToDayMealsRoute,
  appCareDayToDayMemoryRoute: appCareDayToDayMemoryRoute,
  appCareDayToDayMobilityRoute: appCareDayToDayMobilityRoute,
  appCareDayToDayRoutinesRoute: appCareDayToDayRoutinesRoute,
  appCareTeamInviteRoute: appCareTeamInviteRoute,
  appCareTeamIndexRoute: appCareTeamIndexRoute,
  appCareTeamMemberTeamMemberRidRoute: appCareTeamMemberTeamMemberRidRoute,
  appCareTeamMemberEditTeamMemberRidRoute:
    appCareTeamMemberEditTeamMemberRidRoute,
}

const appCareRouteRouteWithChildren = appCareRouteRoute._addFileChildren(
  appCareRouteRouteChildren,
)

interface appOnboardingRouteRouteChildren {
  appOnboardingAccountCreatedRoute: typeof appOnboardingAccountCreatedRoute
  appOnboardingConfirmAssistingRoute: typeof appOnboardingConfirmAssistingRoute
  appOnboardingConfirmInfoRoute: typeof appOnboardingConfirmInfoRoute
  appOnboardingConfirmRoleRoute: typeof appOnboardingConfirmRoleRoute
  appOnboardingCongratsRoute: typeof appOnboardingCongratsRoute
  appOnboardingEnableNotificationsRoute: typeof appOnboardingEnableNotificationsRoute
  appOnboardingInviteCaregiverRoute: typeof appOnboardingInviteCaregiverRoute
  appOnboardingSelectRoleRoute: typeof appOnboardingSelectRoleRoute
  appOnboardingShareInviteRoute: typeof appOnboardingShareInviteRoute
  appOnboardingTermsRoute: typeof appOnboardingTermsRoute
  appOnboardingVisitAddressRoute: typeof appOnboardingVisitAddressRoute
  appOnboardingVisitDetailsRoute: typeof appOnboardingVisitDetailsRoute
  appOnboardingVisitSavedRoute: typeof appOnboardingVisitSavedRoute
  appOnboardingVisitTypeRoute: typeof appOnboardingVisitTypeRoute
}

const appOnboardingRouteRouteChildren: appOnboardingRouteRouteChildren = {
  appOnboardingAccountCreatedRoute: appOnboardingAccountCreatedRoute,
  appOnboardingConfirmAssistingRoute: appOnboardingConfirmAssistingRoute,
  appOnboardingConfirmInfoRoute: appOnboardingConfirmInfoRoute,
  appOnboardingConfirmRoleRoute: appOnboardingConfirmRoleRoute,
  appOnboardingCongratsRoute: appOnboardingCongratsRoute,
  appOnboardingEnableNotificationsRoute: appOnboardingEnableNotificationsRoute,
  appOnboardingInviteCaregiverRoute: appOnboardingInviteCaregiverRoute,
  appOnboardingSelectRoleRoute: appOnboardingSelectRoleRoute,
  appOnboardingShareInviteRoute: appOnboardingShareInviteRoute,
  appOnboardingTermsRoute: appOnboardingTermsRoute,
  appOnboardingVisitAddressRoute: appOnboardingVisitAddressRoute,
  appOnboardingVisitDetailsRoute: appOnboardingVisitDetailsRoute,
  appOnboardingVisitSavedRoute: appOnboardingVisitSavedRoute,
  appOnboardingVisitTypeRoute: appOnboardingVisitTypeRoute,
}

const appOnboardingRouteRouteWithChildren =
  appOnboardingRouteRoute._addFileChildren(appOnboardingRouteRouteChildren)

interface appRouteRouteChildren {
  appCareRouteRoute: typeof appCareRouteRouteWithChildren
  appOnboardingRouteRoute: typeof appOnboardingRouteRouteWithChildren
  appHomeRoute: typeof appHomeRoute
  appRequestsRoute: typeof appRequestsRoute
  appTermsAndConditionsRoute: typeof appTermsAndConditionsRoute
  appAccountDeleteRoute: typeof appAccountDeleteRoute
  appDevResetOnboardingRoute: typeof appDevResetOnboardingRoute
  appVisitsAddRoute: typeof appVisitsAddRoute
  appVisitsRepeatingVisitsRoute: typeof appVisitsRepeatingVisitsRoute
  appVisitsIndexRoute: typeof appVisitsIndexRoute
  appVisitsDetailVisitScheduleRidRoute: typeof appVisitsDetailVisitScheduleRidRoute
  appVisitsEditVisitScheduleRidRoute: typeof appVisitsEditVisitScheduleRidRoute
  appVisitsSummarySuccessRoute: typeof appVisitsSummarySuccessRoute
  appVisitsSummaryAddVisitRidRoute: typeof appVisitsSummaryAddVisitRidRoute
  appVisitsSummaryDetailVisitRidRoute: typeof appVisitsSummaryDetailVisitRidRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appCareRouteRoute: appCareRouteRouteWithChildren,
  appOnboardingRouteRoute: appOnboardingRouteRouteWithChildren,
  appHomeRoute: appHomeRoute,
  appRequestsRoute: appRequestsRoute,
  appTermsAndConditionsRoute: appTermsAndConditionsRoute,
  appAccountDeleteRoute: appAccountDeleteRoute,
  appDevResetOnboardingRoute: appDevResetOnboardingRoute,
  appVisitsAddRoute: appVisitsAddRoute,
  appVisitsRepeatingVisitsRoute: appVisitsRepeatingVisitsRoute,
  appVisitsIndexRoute: appVisitsIndexRoute,
  appVisitsDetailVisitScheduleRidRoute: appVisitsDetailVisitScheduleRidRoute,
  appVisitsEditVisitScheduleRidRoute: appVisitsEditVisitScheduleRidRoute,
  appVisitsSummarySuccessRoute: appVisitsSummarySuccessRoute,
  appVisitsSummaryAddVisitRidRoute: appVisitsSummaryAddVisitRidRoute,
  appVisitsSummaryDetailVisitRidRoute: appVisitsSummaryDetailVisitRidRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface authRouteRouteChildren {
  authAuthConfirmedRoute: typeof authAuthConfirmedRoute
  authLoginRoute: typeof authLoginRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authAuthConfirmedRoute: authAuthConfirmedRoute,
  authLoginRoute: authLoginRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  authRouteRoute: authRouteRouteWithChildren,
  JoinRoute: JoinRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
